export const baseUrl = process.env.NEXT_PUBLIC_MAJELAN_WEBAPP || 'https://beta-play.majelan.audio';

export const randomString = Math.random().toString(36).substring(7);
